<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5FaT0o/image/9781944762872.jpg?1685203788132" alt="This image is the cover for the book All Is Calm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All Is Calm
      </h1>
      <p class="bookDescription body article font2">
        <p>Since Maine’s earliest days, stories have been written about the joys of Christmas in the state. In times of hardship and in times of wealth, Maine and her people have always put the value of Christmas in time shared with family and friends, connections with the natural world, rich traditions and warm woodstoves. This heartwarming and diverse collection of essays, stories, and poetry from the mid-1800s through the Great Depression through today shows that while Christmas trends may change, the warmth, gratitude, and humility of the Maine spirit is evergreen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shannon Butler
      </h2>
      
      <p class="authorDescription body article">Growing up in Aroostook County, Shannon Butler was surrounded by the softly piled snow, warm, cozy farmhouses, and the towering evergreen trees that set the scene for an idyllic and pristine Maine Christmas. A graduate of the University of Maine at Farmington, she now lives in Kennebunk and works at Islandport Press. She still spends every Christmas fireside and surrounded by family in her hometown of Caribou, Maine.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41d6c63c